// extracted by mini-css-extract-plugin
export default {"main":"Page_main__1Ojo5"};